import { render, staticRenderFns } from "./BlogArticles.vue?vue&type=template&id=5ac1a5ee&scoped=true&"
import script from "./BlogArticles.vue?vue&type=script&lang=js&"
export * from "./BlogArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac1a5ee",
  null
  
)

export default component.exports